import dayjs from 'dayjs'
import { useMemo } from 'react'

import {
  isWellImagingObservation,
  WellPage_WellCulture,
} from '~/api/backend/pages/wellPageAPI'
import ConfluenceGraphSidebar, {
  ConfluenceDataset,
} from '~/components/ConfluenceGraphSidebar'

export default function WellConfluenceGraphSidebar({
  culture,
}: {
  culture: WellPage_WellCulture
}) {
  const dataset: ConfluenceDataset = useMemo(
    () => ({
      name: `Well ${culture.well}`,
      data: culture.observationHistory
        .filter(isWellImagingObservation)
        .filter(({ confluence }) => confluence != null)
        .sort((a, b) =>
          a.timestamp < b.timestamp ? -1 : a.timestamp > b.timestamp ? 1 : 0,
        )
        .map(({ timestamp, confluence }) => ({
          timestamp: dayjs(timestamp),
          confluence: confluence!,
        })),
    }),
    [culture.observationHistory],
  )

  if (dataset.data.length === 0 || dataset.data.every(d => d.confluence === 0)) {
    return null
  }

  return (
    <ConfluenceGraphSidebar datasets={{ [culture.id]: dataset }} lineColor='#14919b' />
  )
}
